// extracted by mini-css-extract-plugin
module.exports = {"section":"section__1EYWF","section__content":"section__content__2fJW0","section__error":"section__error__3QLeC","hidden":"hidden__3Tg_t"};